/**
 * Checkout Log + Abandon cart.
 * 1) Writes _bambe_ce on the Shopify cart (bambe.ma) so carts/update can reach PHP even if checkout.bambe.ma is blocked.
 * 2) Also posts text/plain JSON to checkout_event.php when that host is reachable.
 */
(function (w) {
  if (w.BambeCheckoutLog) return;

  var ENDPOINT = '/apps/bambe/checkout_event.php';
  var CONFIG_URL = '/apps/bambe/checkout_log_config.php';
  var CART_ATTR = '_bambe_ce';
  var converted = false;
  var failSent = false;
  var cartCache = null;
  var lastSource = 'cart';
  var lastLeaveKey = '';
  var ownReloadUntil = 0;
  var lastCartJson = '';
  var captureOn = true;
  var captureReady = false;
  var captureLoading = false;
  var captureWait = [];

  function finishCapture(j) {
    if (captureReady) return;
    if (j && j.enabled === false) captureOn = false;
    captureReady = true;
    loadCapture();
  }

  function loadCapture(cb) {
    if (cb) captureWait.push(cb);
    if (captureReady) {
      while (captureWait.length) {
        var fn = captureWait.shift();
        try { fn(); } catch (e1) {}
      }
      return;
    }
    if (captureLoading) return;
    captureLoading = true;
    var name = 'bambeCeCfg' + String(Date.now());
    w[name] = function (j) {
      try { delete w[name]; } catch (e3) {}
      finishCapture(j);
    };
    var s = document.createElement('script');
    s.async = true;
    s.src = CONFIG_URL + '?callback=' + name + '&_=' + Date.now();
    s.onerror = function () {
      finishCapture(null);
    };
    setTimeout(function () {
      finishCapture(null);
    }, 4000);
    (document.head || document.documentElement).appendChild(s);
  }

  function whenCaptureOn(fn) {
    loadCapture(function () {
      if (captureOn) fn();
    });
  }

  loadCapture();

  function cid() {
    var k = 'bambe_ce_cid';
    try {
      var v = localStorage.getItem(k);
      if (v) return v;
      v = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(k, v);
      return v;
    } catch (e) {
      return 'c' + Date.now().toString(36);
    }
  }

  function field(id) {
    var el = document.getElementById(id);
    return el && el.value ? String(el.value).trim() : '';
  }

  function validPhone(v) {
    try {
      if (w.BambeGtmBridge && typeof w.BambeGtmBridge.normalizeMaPhone === 'function') {
        return !!w.BambeGtmBridge.normalizeMaPhone(v);
      }
    } catch (e) {}
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('00212') === 0) d = d.slice(2);
    if (d.indexOf('212') === 0) d = '0' + d.slice(3).replace(/^0/, '');
    return /^0[567]\d{8}$/.test(d);
  }

  function parseDh(text) {
    var n = parseFloat(String(text || '').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function detectSource() {
    var overlay = document.getElementById('pcOverlay');
    if (overlay && overlay.classList.contains('active')) return 'popup';
    var ae = document.activeElement;
    if (ae && ae.id && ae.id.indexOf('pc-') === 0) return 'popup';
    return lastSource || 'cart';
  }

  function lineItem(it) {
    it = it || {};
    var price = it.final_price != null ? it.final_price : it.price;
    if (typeof price === 'number' && price > 500) price = price / 100;
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.variant || '');
    return {
      title: it.product_title || it.title || '',
      variant: variant,
      qty: Number(it.quantity || it.qty || 1) || 1,
      price: Number(price || 0) || 0,
      sku: String(it.sku || ''),
      variant_id: Number(it.variant_id || it.id || 0) || 0,
      product_id: Number(it.product_id || 0) || 0
    };
  }

  function mapShopifyItems(items) {
    if (!items || !items.length) return [];
    return items.slice(0, 20).map(lineItem);
  }

  function snapshotItems() {
    var el = document.getElementById('bambe-ce-cart-snapshot');
    if (!el) return [];
    try {
      var arr = JSON.parse(el.textContent || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function popupItems() {
    var qtyEl = document.querySelector('.quantity__input[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;
    var title = '';
    var unit = 0;
    var variantId = 0;
    var productId = 0;
    var sku = '';
    var c = {};
    try {
      var cfg = document.getElementById('bambe-popup-checkout-config');
      if (cfg) {
        c = JSON.parse(cfg.textContent || '{}');
        title = c.productTitle || '';
        unit = Number(c.price) || 0;
        variantId = Number(c.variantId) || 0;
        productId = Number(c.productId) || 0;
        sku = c.sku || '';
      }
    } catch (e) {}
    var recap = document.getElementById('pcRecapTitle');
    if (!title && recap) title = recap.textContent || '';
    var variant = '';
    var root = document.querySelector('.product--parent') || document;
    var checked = root.querySelector('input[type="radio"][name^="options"]:checked, fieldset input:checked');
    if (checked) variant = checked.getAttribute('value') || checked.value || '';
    var hidden = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form input[name="id"], input[name="id"]');
    if (hidden) variantId = Number(hidden.value) || variantId;
    if (c.variantSkus && c.variantSkus[String(variantId)]) sku = c.variantSkus[String(variantId)];
    if (c.variantOptions && c.variantOptions[String(variantId)]) variant = c.variantOptions[String(variantId)];
    var meta = document.getElementById('pcRecapMeta');
    if (!variant && meta) variant = (meta.textContent || '').trim();
    return [{ title: title, variant: variant, qty: qty, price: unit, sku: sku, variant_id: variantId, product_id: productId }];
  }

  function money(source) {
    if (source === 'popup') {
      var sub = parseDh((document.getElementById('pcSubtotal') || {}).textContent);
      var shipEl = document.getElementById('pcShipping');
      var shipText = (shipEl && shipEl.textContent) || '';
      var shipping = /مجاني|gratuit/i.test(shipText) ? 0 : parseDh(shipText);
      var total = parseDh((document.getElementById('pcTotal') || {}).textContent);
      return { subtotal: sub, shipping: shipping, total: total || sub + shipping };
    }
    var subtotal = Number((document.querySelector('#ce_input_price') || {}).value) || 0;
    var shippingC = Number((document.querySelector('#ce_input_shipping_fees') || {}).value) || 0;
    return { subtotal: subtotal, shipping: shippingC, total: subtotal + shippingC };
  }

  function payload(source, extra) {
    extra = extra || {};
    source = extra.source || source || detectSource();
    lastSource = source;
    var ids =
      source === 'popup'
        ? { name: 'pc-name', phone: 'pc-phone', city: 'pc-city', address: 'pc-address' }
        : { name: 'ce_input_name', phone: 'ce_input_phone', city: 'ce_input_city', address: 'ce_input_address' };
    var m = money(source);
    var items = extra.items;
    if (!items) {
      items = source === 'popup' ? popupItems() : mapShopifyItems(cartCache && cartCache.items);
      if (source !== 'popup' && (!items || !items.length)) items = snapshotItems();
    }
    var out = {
      source: source,
      name: extra.name != null ? extra.name : field(ids.name),
      phone: extra.phone != null ? extra.phone : field(ids.phone),
      city: extra.city != null ? extra.city : field(ids.city),
      address: extra.address != null ? extra.address : field(ids.address),
      items: items,
      subtotal: extra.subtotal != null ? extra.subtotal : m.subtotal,
      shipping: extra.shipping != null ? extra.shipping : m.shipping,
      total: extra.total != null ? extra.total : m.total,
      page_url: w.location.href,
      referring_site: document.referrer || '',
      user_agent: navigator.userAgent || '',
      client_id: cid()
    };
    if (extra.kind) out.kind = extra.kind;
    if (extra.reason) out.reason = extra.reason;
    if (extra.whatsapp_clicked) out.whatsapp_clicked = true;
    return out;
  }

  function cartBlob(data) {
    var o = {
      v: 1,
      kind: data.kind || '',
      reason: data.reason || '',
      source: data.source || '',
      name: data.name || '',
      phone: data.phone || '',
      city: data.city || '',
      address: data.address || '',
      items: (data.items || []).slice(0, 8).map(function (it) {
        it = it || {};
        return {
          title: it.title || '',
          variant: it.variant || '',
          qty: it.qty || 1,
          price: it.price || 0,
          sku: it.sku || '',
          variant_id: it.variant_id || 0,
          product_id: it.product_id || 0
        };
      }),
      subtotal: data.subtotal || 0,
      shipping: data.shipping || 0,
      total: data.total || 0,
      client_id: data.client_id || '',
      page_url: String(data.page_url || '').slice(0, 180)
    };
    if (data.whatsapp_clicked) o.whatsapp_clicked = 1;
    o.ts = Date.now();
    var s = JSON.stringify(o);
    if (s.length > 1800) {
      o.items = o.items.slice(0, 3);
      o.page_url = '';
      s = JSON.stringify(o);
    }
    return s;
  }

  function saveCart(data, clear) {
    try {
      var value = clear ? '' : cartBlob(data);
      if (!clear && value === lastCartJson) return;
      lastCartJson = value;
      var attrs = {};
      attrs[CART_ATTR] = value;
      var note = clear ? '' : 'BAMBE_CE:' + value;
      var jsonBody = JSON.stringify({ attributes: attrs, note: note });
      var sent = false;
      if (clear !== true && data && data._beacon && navigator.sendBeacon) {
        try {
          var params = new URLSearchParams();
          params.append('attributes[' + CART_ATTR + ']', value);
          params.append('note', note);
          sent = !!navigator.sendBeacon('/cart/update.js', params);
        } catch (e1) {}
      }
      if (!sent) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: jsonBody,
          keepalive: true,
          credentials: 'same-origin'
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function post(data, beacon) {
    try {
      var body = JSON.stringify(data);
      var sent = false;
      if (beacon && navigator.sendBeacon) {
        sent = !!navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
      }
      if (!sent) {
        fetch(ENDPOINT, {
          method: 'POST',
          mode: 'cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
          body: body
        }).catch(function () {});
      }
    } catch (e) {}
  }

  var api = {
    fail: function (source, reason, extra) {
      extra = extra || {};
      extra.kind = 'fail';
      extra.reason = reason || 'connection_error';
      extra.source = source;
      var p = payload(source, extra);
      // DROP needs the whole form; the server re-checks.
      if (!p.name || !validPhone(p.phone) || !p.city || !p.address) return;
      failSent = true;
      whenCaptureOn(function () {
        saveCart(p, false);
        post(p, true);
      });
    },
    converted: function (source, extra) {
      converted = true;
      try {
        sessionStorage.setItem('bambe_ce_converted_at', String(Date.now()));
      } catch (e) {}
      extra = extra || {};
      extra.kind = 'converted';
      extra.source = source;
      saveCart({}, true);
      whenCaptureOn(function () {
        post(payload(source, extra), false);
      });
    },
    abandon: function (source) {
      if (converted || failSent) return;
      try {
        var t = parseInt(sessionStorage.getItem('bambe_ce_converted_at') || '0', 10);
        if (t && Date.now() - t < 120000) return;
      } catch (e) {}
      source = source || detectSource();
      var p = payload(source, { kind: 'abandon', source: source });
      // Abandon needs a valid phone; other fields optional.
      if (!validPhone(p.phone)) return;
      // Send again only if the form changed since the last time the page was hidden.
      var key = JSON.stringify([p.source, p.name, p.phone, p.city, p.address, (p.items || []).map(function (it) {
        return it.variant_id + 'x' + it.qty;
      })]);
      if (key === lastLeaveKey) return;
      lastLeaveKey = key;
      p._beacon = true;
      whenCaptureOn(function () {
        saveCart(p, false);
        post(p, true);
      });
    },
    // Called when confirm is clicked with an incomplete form. No longer blocks the
    // abandon: a customer with a valid phone who then leaves is still a lead.
    skipAbandon: function () {},
    setCart: function (cart) {
      if (cart) cartCache = cart;
    }
  };

  w.BambeCheckoutLog = api;

  // The form saved on the cart stays there after the visit. Clear it once it is old,
  // so a later cart change does not replay it to the server as a new lead.
  var CART_BLOB_MAX_AGE = 30 * 60 * 1000;

  function clearStaleCartBlob() {
    try {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (!cart || lastCartJson) return; // already written during this visit
          var raw = (cart.attributes && cart.attributes[CART_ATTR]) || '';
          var note = typeof cart.note === 'string' ? cart.note : '';
          var noteOurs = note.indexOf('BAMBE_CE:') === 0;
          if (!raw && !noteOurs) return;
          var ts = 0;
          try {
            ts = Number(JSON.parse(raw || note.slice(9)).ts) || 0;
          } catch (e1) {}
          if (ts && Date.now() - ts < CART_BLOB_MAX_AGE) return;
          var attrs = {};
          attrs[CART_ATTR] = '';
          var body = { attributes: attrs };
          if (noteOurs) body.note = ''; // never touch a note the customer wrote
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
            credentials: 'same-origin'
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  clearStaleCartBlob();

  function isErrorWhatsAppLink(a) {
    if (!a || !a.getAttribute) return false;
    if (a.id === 'floating-contact-link') return false;
    if (a.closest && a.closest('.floating-contact, .tt-footer, .bambe-bl-alert, .whatsapp-link')) return false;
    var href = a.getAttribute('href') || a.href || '';
    if (!/whatsapp|wa\.me/i.test(href)) return false;
    if (a.classList && a.classList.contains('ce-conn-error-wa')) return true;
    if (a.closest && a.closest('#ce-order-alert, #pcAlert, .pc-alert, .pc-error, .ce-order-alert')) return true;
    var decoded = href;
    try {
      decoded = decodeURIComponent(href);
    } catch (e) {}
    return /حصل خطأ أريد الطلب|Erreur je veux commander|Erreur commande/i.test(decoded);
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      // "Add another product" reloads the page: that is not the customer leaving.
      if (t && t.closest && t.closest('#pcAddMore')) {
        ownReloadUntil = Date.now() + 15000;
        return;
      }
      var a = t && t.closest ? t.closest('a') : null;
      if (!isErrorWhatsAppLink(a)) return;
      api.fail(detectSource(), 'connection_error', { whatsapp_clicked: true });
    },
    true
  );

  function onLeave() {
    if (Date.now() < ownReloadUntil) return;
    api.abandon();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') onLeave();
  });
  w.addEventListener('pagehide', onLeave);

  function bindFields() {
    ['ce_input_name', 'ce_input_phone', 'ce_input_city', 'ce_input_address', 'pc-name', 'pc-phone', 'pc-city', 'pc-address'].forEach(
      function (id) {
        var el = document.getElementById(id);
        if (!el || el.dataset.ceLogBound) return;
        el.dataset.ceLogBound = '1';
        el.addEventListener('input', function () {
          lastSource = id.indexOf('pc-') === 0 ? 'popup' : 'cart';
        });
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFields);
  } else {
    bindFields();
  }
  document.addEventListener('shopify:section:load', bindFields);
})(window);
